// Contain the inspection card in the visible part of the plotting canvas.
export function chartTooltipPlacement({canvas,tooltip,point,viewport,topInset=8}){
 const width=Math.min(tooltip.width,Math.max(0,canvas.width-16)),height=tooltip.height;
 const left=Math.max(8,Math.min(Math.max(8,canvas.width-width-8),point.x-width/2));
 const minTop=Math.max(8,topInset-canvas.top),maxTop=Math.max(minTop,Math.min(canvas.height-height-8,viewport.height-canvas.top-height-8));
 const preferred=point.y-height-18>=minTop?point.y-height-18:point.y+18;
 return {left,top:Math.max(minTop,Math.min(maxTop,preferred))};
}
